import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { SelectWrapper, StyledSelect, StyledOption } from './LanguageSwitcher.styles';
import enFlag from '../../assets/flags/en.svg';
import deFlag from '../../assets/flags/de.svg';
import { setLocalStorageItem } from '../../services/local-storage.service';
import { LOCAL_STORAGE_LANGUAGE_KEY } from '../../i18n/i18n';
import { environment } from '../../../environments/environment';
import { updateLanguage } from '../../services/user.service';
import { useLocation } from 'react-router-dom';
import { AuthContext } from '../../contexts/auth.context';

const languages = {
  en: {
    name: 'EN',
    flag: enFlag,
  },
  de: {
    name: 'DE',
    flag: deFlag,
  },
};

const LanguageSwitcher = () => {
  const { auth } = useContext(AuthContext);
  const { i18n } = useTranslation();
  const location = useLocation();
  const checkPage = /^\/checks\/[^\/]+\/report$/;

  const handleLanguageChange = (value: string) => {
    i18n.changeLanguage(value);
    if (auth !== null) {
      updateLanguage(value);
    }
    setLocalStorageItem(LOCAL_STORAGE_LANGUAGE_KEY, value);
  };

  if (!environment.language) {
    return null;
  }

  const hideLanguage = checkPage.test(location.pathname);

  return (
    <SelectWrapper
      style={{
        visibility: hideLanguage ? 'hidden' : 'visible',
      }}>
      <StyledSelect value={i18n.language} onChange={e => handleLanguageChange(e.target.value)}>
        {Object.entries(languages).map(([code, { name }]) => (
          <StyledOption key={code} value={code}>
            {name}
          </StyledOption>
        ))}
      </StyledSelect>
    </SelectWrapper>
  );
};

export default LanguageSwitcher;
